export const ddns = {
  sys_dnshost_account: "sys_dnshost_netgear_account",
  sys_dnsmail_account: "sys_dnsmail_netgear_account",
  sys_dnspassword_account: "sys_dnspassword_netgear_account",
  sys_dnshost: "sys_dnshost_netgear",
  sys_dnspassword: "sys_dnspassword_netgear",
  ddns_reg_agree: "netgearRegisterActive",
};

export default ddns;
